import axios from 'axios';
import store from '../store';

function getLanguageList () {
  return axios.get('api/languages');
}

function getLanguageListWithRoute (tourId) {
  return axios.get('api/getLanguageListWithRoute/' + tourId);
}

function checkRouteHasLanguage (routeID) {
  return axios.get('api/checkRouteHasLanguage/currentRouteId/' + routeID);
}

function delLanguage (id) {
  return axios.get('api/del-language/' + id);
}

function getTourLanguageList (tourId) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.get('api/client/' + currentClientId + '/languages/' + tourId);
}

function newLanguage (newLanguage) {
  return axios.post('api/languages', {
    code: newLanguage.code,
    language: newLanguage.language
  });
}

function newTourLanguage (data) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/languages/tours', {
    tourId: data.tourId,
    languageIds: data.addLanguages,
    order: data.languageOrder
  });
}

function removeTourLanguage (data) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/languages/tours/remove', {
    tourId: data.tourId,
    languageId: data.languageId
  });
}

function removeTourLanguages (data) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/languages/tours/removes', {
    tourId: data.tourId,
    languageId: data.languageId
  });
}

function updateTourLanguages (data) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/languages/tours/update', {
    tourId: data.tourId,
    languageOrder: data.languageOrder
  });
}

export {
  getLanguageList,
  getTourLanguageList,
  newLanguage,
  newTourLanguage,
  removeTourLanguage,
  removeTourLanguages,
  updateTourLanguages,
  delLanguage,
  getLanguageListWithRoute,
  checkRouteHasLanguage
};



// WEBPACK FOOTER //
// ./src/services/LanguageService.js